import { setDataChatResults, setIsloading } from "../features/chatbotSlice";
import { setIsLoading as setIsLoadingGenie } from '../features/genieSlice'

import {
	createApi,
	fetchBaseQuery
} from "@reduxjs/toolkit/query/react";
import { setIsConversationOpen, setResults, setWorkspaceId } from "../features/genieSlice";

const APIM_SUBSCRIPTION_VALUE = process.env.REACT_APP_DATA_CHATBOT_APIM_SUBSCRIPTION_VALUE
const BASE_URL = process.env.REACT_APP_DATA_CHATBOT_API_URL

export interface KBQueryParam {
	query: string,
	email: string
}

export interface StringMap {
	[key: string]: string
}

export interface DataResultType {
	data: StringMap[],
	error: any,
	isLoading: boolean,
	isError?: boolean
}

export const dataApi = createApi({
	reducerPath: "dataApi",
	baseQuery: fetchBaseQuery({
		baseUrl: BASE_URL,
		prepareHeaders: async (headers) => {
			headers.set('Content-Type', `application/json`)
			headers.set('Ocp-Apim-Subscription-Key', `${APIM_SUBSCRIPTION_VALUE}`)
			return headers
		}
	}),
	tagTypes: ["dataApi"],
	endpoints: (builder) => ({
		postQuestion: builder.mutation({
			query: (body: KBQueryParam) => ({
				url: `/data`,
				method: 'POST',
				body
			}),
			async onQueryStarted({ query }, { dispatch, getState, queryFulfilled }) {
				dispatch(setIsloading(true))
				try {
					const { data } = await queryFulfilled
					dispatch(setDataChatResults({ query, answer: data }))
				} catch (err) {
				}
				dispatch(setIsloading(false))
			}
		}),
		classify: builder.mutation({
			query: (body: KBQueryParam) => ({
				url: `/classify`,
				method: 'POST',
				body
			}),
			async onQueryStarted(body, { dispatch, getState, queryFulfilled }) {
				dispatch(setIsLoadingGenie(true))
				try {
					const { data } = await queryFulfilled
					dispatch(setIsloading(false))
					if (!data?.workspace_id) {
						dispatch(setResults(
							{
								"id": "01f0830cfdcd1a079c32a301a7d1b129",
								"space_id": "01f00a5547061439af4c5c76c271662f",
								"conversation_id": "01f0830c29881f8db6bbf2be54dbf870",
								"user_id": 8869644753828818,
								"created_timestamp": 1756275226944,
								"last_updated_timestamp": 1756275229672,
								"status": "COMPLETED",
								"content": body.query,
								"type": "content",
								"text": {
									"content": data?.description
								},
								"attachments": [
									{
										"text": {
											"content": data?.description
										},
										"attachment_id": "01f0830cff6a1ccebf4b9b969df4409b"
									}
								],
								"auto_regenerate_count": 0,
								"message_id": "01f0830cfdcd1a079c32a301a7d1b129",
								"question": body.query
							}
							/*{
							attachments: [{
								text: {
									content: data?.description,
								},
								attachment: "xyz id"
							}],
							content: body.query,
							question: body.query,
							type: 'content',
							status: 'COMPLETED'
						}*/));
						dispatch(setIsConversationOpen(false))
					} else {
						dispatch(setWorkspaceId(data?.workspace_id))
					}
					dispatch(setIsLoadingGenie(false))
					return data
				} catch (err) {
					dispatch(setIsLoadingGenie(false))
				}
			}
		})
	})
})

export const {
	usePostQuestionMutation,
	useClassifyMutation
} = dataApi;